export const getTipModalConfirmStatus = () =>
  new Promise((res) => {
    const interval = setInterval(() => {
      const okBtn = document.querySelector('#dbi_filter_modal_ok_btn');
      const cancelBtn = document.querySelector('#dbi_filter_modal_cancel_btn');
      const closeBtn = document.querySelector('.dbi_filter_tip_modal .tea-btn.tea-btn--icon');

      if (okBtn && cancelBtn && closeBtn) {
        clearInterval(interval);

        okBtn?.addEventListener('click', () => {
          res(true);
        });
        cancelBtn?.addEventListener('click', () => {
          res(false);
        });
        closeBtn?.addEventListener('click', () => {
          res(false);
        });
      }
    }, 100);
  });
